import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Output} from "@angular/core";
import {Router} from "@angular/router";
import {FUIModalsService} from "@fedelta-pos/ui";
import {AuthApiService} from "../../auth/auth-api.service";


@Component({
    selector: "fhm-signup-page-modal",
    styleUrls: ["./signup-page-modal.component.scss"],
    templateUrl: "./signup-page-modal.component.html",
    providers: [AuthApiService],
    standalone: false
})
export class SignupPageModalComponent implements AfterViewInit {

    @Output() closed: EventEmitter<any> = new EventEmitter();

    state: boolean = true;

    url: string;

    constructor(private modalsService: FUIModalsService,
                private router: Router,
                private changeDetectorRef: ChangeDetectorRef) {

    }

    cancel(): void {
        this.closed.emit();
        this.modalsService.close(this);
    }


    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    async init(url: string): Promise<void> {
        this.url = url;
    }
}
